import { Component, inject, OnInit } from '@angular/core';
import { Toolbar } from "../toolbar/toolbar";
import { Sidenav } from "../sidenav/sidenav";
import { tap } from 'rxjs';
import { AppService } from '../../services/app.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-core',
  imports: [Toolbar, Sidenav],
  templateUrl: './core.html',
  styleUrl: './core.scss'
})
export class CoreComponent implements OnInit {
  private readonly appService = inject(AppService);
  public readonly authService = inject(AuthService);


  ngOnInit(): void {
    this.appService.setTheme();
    this.appService.checkForUpdates().pipe(
      tap(sw => console.log(sw.type)),
      // Enable for Push notifications
      // switchMap(() => this.appService.requestNotifications())
    ).subscribe();
    this.authService.authorize().subscribe();
  }


}
